// Free express shipping progress bar. Markup and thresholds: snippets/free-shipping-bar.liquid
// Renders into a shadow root: the cart morph rebuilds light DOM children on every update,
// but it only syncs this element's attributes, which triggers a re-render here.

const STYLES = `
  :host { display: block; }
  p {
    margin: 0 0 8px;
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    line-height: 1.4;
  }
  .track {
    height: 2px;
    background: rgb(var(--color-foreground-rgb, 0 0 0) / 0.15);
    overflow: hidden;
  }
  .fill {
    height: 100%;
    width: 0;
    background: var(--color-foreground, #000);
    transition: width 0.4s ease-out;
  }
`;

if (!customElements.get('free-shipping-bar')) {
  customElements.define(
    'free-shipping-bar',
    class extends HTMLElement {
      static get observedAttributes() {
        return ['data-total', 'data-currency', 'data-threshold', 'data-threshold-currency'];
      }

      connectedCallback() {
        if (!this.shadowRoot) {
          const root = this.attachShadow({ mode: 'open' });
          root.innerHTML = `<style>${STYLES}</style><p aria-live="polite"></p><div class="track" aria-hidden="true"><div class="fill"></div></div>`;
        }
        this.update();
      }

      attributeChangedCallback() {
        if (this.shadowRoot) this.update();
      }

      update() {
        const { total, threshold, thresholdCurrency, currency, locale, textRemaining, textUnlocked } = this.dataset;
        let goal = Number(threshold);
        if (thresholdCurrency !== currency) {
          const rate = Number(window.Shopify?.currency?.rate);
          if (!rate) {
            this.style.display = 'none';
            return;
          }
          goal = Math.ceil((goal * rate) / 100) * 100;
        }
        this.style.display = '';

        const remaining = goal - Number(total);
        const text = this.shadowRoot.querySelector('p');
        const fill = this.shadowRoot.querySelector('.fill');

        if (remaining > 0) {
          let amount;
          try {
            amount = new Intl.NumberFormat(locale, {
              style: 'currency',
              currency,
              maximumFractionDigits: remaining % 100 === 0 ? 0 : 2,
            }).format(remaining / 100);
          } catch {
            amount = `${(remaining / 100).toFixed(2)} ${currency}`;
          }
          text.textContent = textRemaining.replace('[amount]', amount);
          fill.style.width = `${Math.max(4, (Number(total) / goal) * 100)}%`;
        } else {
          text.textContent = textUnlocked;
          fill.style.width = '100%';
        }
      }
    }
  );
}
